import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { hideDialog } from '../../../core/actions';
import FileUploadForm from '../../../core/components/FileUploadForm';
import ModalDialog from '../../../core/components/Modal';
import { FileType } from '../models';

export class UpsertFileDialog extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    file: PropTypes.shape({}).isRequired,
    fileType: PropTypes.oneOf([FileType.image, FileType.video, FileType.document]).isRequired,
    isOpen: PropTypes.bool.isRequired,
    closeDialog: PropTypes.func.isRequired,
    initialFormValues: PropTypes.shape({}),
    intl: PropTypes.shape({}).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
    };
    this.formRef = React.createRef();
  }

  // Convert a base64 data URL or raw base64 string to a Blob
  dataURLToBlob = (dataUrl, mimeType) => {
    if (!dataUrl) return null;
    const base64String = dataUrl.includes(',') ? dataUrl.split(',')[1] : dataUrl;
    try {
      const byteChars = atob(base64String);
      const byteNumbers = new Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) {
        byteNumbers[i] = byteChars.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      return new Blob([byteArray], { type: mimeType || 'application/octet-stream' });
    } catch (e) {
      return null;
    }
  };

  onReady = () => {
    if (this.formRef.current && this.formRef.current.submit) {
      this.formRef.current.submit();
    }
  };

  onSubmit = (data) => {
    // Ensure we submit a real File/Blob for FormData
    let filePayload = data && data.file;
    if (!(filePayload instanceof Blob)) {
      const snapshot = this.props.file || {};
      const name = (filePayload && filePayload.name) || snapshot.name || 'upload';
      const type = (filePayload && filePayload.type) || snapshot.type || 'application/octet-stream';
      const blob = this.dataURLToBlob(snapshot.base64, type);
      if (blob) {
        try {
          filePayload = new File([blob], name, { type });
        } catch (e) {
          // Fallback for environments without File constructor
          blob.name = name;
          filePayload = blob;
        }
      }
    }

    const submitData = { ...data, file: filePayload };

    this.setState({ submitting: true }, () => {
      this.props.onSubmit(submitData);
    });
  };

  render() {
    const { closeDialog, isOpen, file, fileType, initialFormValues } = this.props;
    const intl = this.props.intl;
    const preparedFile = file
      ? {
          base64: file.base64 || '',
          fileList: [
            {
              name: file.name || 'upload',
              type: file.type || 'application/octet-stream',
            },
          ],
        }
      : { base64: '', fileList: [{ name: '', type: '' }] };

    return (
      <ModalDialog
        title={intl.formatMessage({ id: 'uploadFile' })}
        onReady={this.onReady}
        isOpen={isOpen}
        close={closeDialog}
        showFooter={!this.state.submitting}
      >
        {!this.state.submitting ? (
          <FileUploadForm
            ref={this.formRef}
            file={preparedFile}
            fileType={fileType}
            onSubmit={this.onSubmit}
            initialValues={initialFormValues}
          />
        ) : (
          <span>{intl.formatMessage({ id: 'uploading' })}...</span>
        )}
      </ModalDialog>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // Do not derive File instances from Redux state; keep initial values simple
  const initialFormValues = {
    description: '',
  };
  return { initialFormValues };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeDialog: hideDialog,
    },
    dispatch
  );
};

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl);

export default enhance(UpsertFileDialog);
